import { useEffect } from "react";
import { useFormik } from "formik";
import { Row, Col, Form as BTForm } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { Input, Form, Select } from "components/Form";
import { Loader } from "components/Loader";
import { ALL_FEATURES } from "utils/constants";
import { sendBugDetails } from "../../service";
import { toast } from "Layout/slice";
import { parseErrorMessage } from "utils";
import { userDetailSelect } from "Layout/slice/selector";
import { loggedInState } from "features/Auth/slice/selector";
import { HelpCenterSubCardContainer } from "../HelpCenter.styles";
import { Heading } from "style/components/Heading.styles";
import { Button } from "components/Button";
import { IconClose } from "assets/icons";
import {
  reportBugInitialValues,
  reportBugValidationSchema,
} from "../../validation";

const ReportBug = ({ handleMenuClose }) => {
  const dispatch = useDispatch();
  const userDetail = useSelector(userDetailSelect);
  const isLoggedInState = useSelector(loggedInState);

  useEffect(() => {
    formik.values.name = "";
    formik.values.email = "";
    if (isLoggedInState) {
      formik.values.name = userDetail.first_name + " " + userDetail.last_name;
      formik.values.email = userDetail.email;
    }
  }, []);

  const handleSubmit = async (values) => {
    try {
      await sendBugDetails(values);
      formik.resetForm();
      dispatch(
        toast({
          type: "info",
          body: "The request has been sent, Thank you!",
        })
      );
    } catch (error) {
      console.error(error);
      dispatch(
        toast({
          type: "error",
          body: parseErrorMessage(error),
        })
      );
    }
  };

  const formik = useFormik({
    initialValues: reportBugInitialValues,
    validationSchema: reportBugValidationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <HelpCenterSubCardContainer>
      <div className="wrapper">
        <div className="header">
          <Heading>Report a Bug</Heading>
          <IconClose
            fill="#048AF5"
            className="close-icon"
            height={24}
            width={24}
            onClick={handleMenuClose}
          />
        </div>

        <Form className="form" onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={6}>
              <Input
                disabled={isLoggedInState}
                label="Name*"
                placeholder="Enter Name"
                isInvalid={formik.touched.name && formik.errors.name}
                {...formik.getFieldProps("name")}
              />
            </Col>
            <Col md={6}>
              <Input
                disabled={isLoggedInState}
                label="Email*"
                placeholder="Enter Email"
                isInvalid={formik.touched.email && formik.errors.email}
                {...formik.getFieldProps("email")}
              />
            </Col>

            <BTForm.Group className="input-form">
              <div className="d-flex justify-content-between">
                <BTForm.Label className="input-form-label">
                  Select a Feature*
                </BTForm.Label>
              </div>
              <Select
                options={ALL_FEATURES}
                placeholder="Select feature"
                className="mb-4 select-feature-dd"
                name="select_feature"
                value={
                  ALL_FEATURES.find(
                    (feature) => feature.value === formik.values.select_feature
                  ) || ""
                }
                onChange={(val) => {
                  formik.setFieldValue("select_feature", val.value);
                }}
              />
            </BTForm.Group>
            {formik.touched.select_feature && formik.errors.select_feature ? (
              <div className="form-error">{formik.errors.select_feature}</div>
            ) : null}

            <Input
              label="Bug Title*"
              placeholder="Enter Bug title"
              isInvalid={formik.touched.bug_title && formik.errors.bug_title}
              {...formik.getFieldProps("bug_title")}
            />

            <Input
              label="Bug Description*"
              type="textarea"
              className="bug-description-input"
              placeholder="Enter Bug Description......"
              rows={6}
              as="textarea"
              isInvalid={
                formik.touched.bug_description && formik.errors.bug_description
              }
              {...formik.getFieldProps("bug_description")}
            />

            <div className="btn-submit">
              <Button type="submit" disabled={!formik.isValid}>
                {formik.isSubmitting ? <Loader className="on-btn" /> : "Submit"}
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </HelpCenterSubCardContainer>
  );
};

ReportBug.propTypes = {
  handleMenuClose: PropTypes.func,
};

export { ReportBug };
